import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // SmartText (editorial) state
  smartText: {
    formData: {
      keyword: '',
      url: '',
      titleTag: '',
      metaDescriptionTag: '',
    },
    agentSettings: {
      customAgent: '',
      wordsPerText: 0,
      useGpt: true,
      useClaude: false,
      useBoth: false,
    },
    editorContent: '',
    websites: '',
    selectedWebsite: null,
    selectedAgent: null,
    hasGeneratedOnce: false,
    showEditor: false,
    currentContentScore: null,
    currentTextId: null,
    list: [],
    keywords: '',
    combinedKeywords: '',
    timestamp: null,
  },
  // Translation state
  translation: {
    formData: {
      keyword: '',
      url: '',
      titleTag: '',
      metaDescriptionTag: '',
      agentIA: '',
      websiteId: ''
    },
    editorContent: '',
    translatedContent: '',
    currentTextId: null,
    translationAgents: [],
    selectedAgent: null,
    timestamp: null,
  },
};

const smartTextFormSlice = createSlice({
  name: 'smartTextForm',
  initialState,
  reducers: {
    // SmartText (editorial) actions
    saveSmartTextSnapshot: (state, action) => {
      state.smartText = { ...action.payload, timestamp: Date.now() };
    },
    clearSmartTextSnapshot: (state) => {
      state.smartText = initialState.smartText;
    },

    // Translation actions
    saveTranslationSnapshot: (state, action) => {
      state.translation = { ...action.payload, timestamp: Date.now() };
    },
    clearTranslationSnapshot: (state) => {
      state.translation = initialState.translation;
    },

    // Legacy/common actions (kept for backward compatibility)
    saveFormSnapshot: (state, action) => {
      state.smartText = { ...action.payload, timestamp: Date.now() };
    },
    clearFormSnapshot: (state) => {
      state.smartText = initialState.smartText;
    },
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.smartText.formData[field] = value;
    },
    updateAgentSetting: (state, action) => {
      const { field, value } = action.payload;
      state.smartText.agentSettings[field] = value;
    },
    updateEditorContent: (state, action) => {
      state.smartText.editorContent = action.payload;
    },
    setCurrentTextId: (state, action) => {
      state.smartText.currentTextId = action.payload;
    },
  },
});

export const {
  // SmartText
  saveSmartTextSnapshot,
  clearSmartTextSnapshot,
  // Translation
  saveTranslationSnapshot,
  clearTranslationSnapshot,
  // Legacy/common
  saveFormSnapshot,
  clearFormSnapshot,
  updateFormField,
  updateAgentSetting,
  updateEditorContent,
  setCurrentTextId,
} = smartTextFormSlice.actions;

// Selectors
export const smartTextFormSelector = (state) => state.smartTextForm.smartText;
export const translationFormSelector = (state) => state.smartTextForm.translation;

export default smartTextFormSlice.reducer;

